module.exports = __webpack_public_path__ + "img/valid.4af43503.png";